/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SessionRouteImport } from './routes/_session'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppChangelogRouteImport } from './routes/_app/changelog'
import { Route as AppMyPhonesRouteImport } from './routes/_app/my-phones'
import { Route as AppProvidersRouteImport } from './routes/_app/providers'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin.audit'
import { Route as AppAdminNetworkRouteImport } from './routes/_app/admin.network'
import { Route as AppAdminPreloadRouteImport } from './routes/_app/admin.preload'
import { Route as AppAdminProvidersRouteImport } from './routes/_app/admin.providers'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin.settings'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin.users'
import { Route as AppDevicesIndexRouteImport } from './routes/_app/devices.index'
import { Route as AppDevicesDeviceIdRouteImport } from './routes/_app/devices.$deviceId'
import { Route as SessionDevicesDeviceIdPopoutRouteImport } from './routes/_session/devices.$deviceId.popout'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionRoute = SessionRouteImport.update({
  id: '/_session',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppChangelogRoute = AppChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppMyPhonesRoute = AppMyPhonesRouteImport.update({
  id: '/my-phones',
  path: '/my-phones',
  getParentRoute: () => AppRoute,
} as any)
const AppProvidersRoute = AppProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminNetworkRoute = AppAdminNetworkRouteImport.update({
  id: '/admin/network',
  path: '/admin/network',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminPreloadRoute = AppAdminPreloadRouteImport.update({
  id: '/admin/preload',
  path: '/admin/preload',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminProvidersRoute = AppAdminProvidersRouteImport.update({
  id: '/admin/providers',
  path: '/admin/providers',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesIndexRoute = AppDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => AppRoute,
} as any)
const AppDevicesDeviceIdRoute = AppDevicesDeviceIdRouteImport.update({
  id: '/devices/$deviceId',
  path: '/devices/$deviceId',
  getParentRoute: () => AppRoute,
} as any)
const SessionDevicesDeviceIdPopoutRoute =
  SessionDevicesDeviceIdPopoutRouteImport.update({
    id: '/devices/$deviceId/popout',
    path: '/devices/$deviceId/popout',
    getParentRoute: () => SessionRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/changelog': typeof AppChangelogRoute
  '/my-phones': typeof AppMyPhonesRoute
  '/providers': typeof AppProvidersRoute
  '/settings': typeof AppSettingsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/network': typeof AppAdminNetworkRoute
  '/admin/preload': typeof AppAdminPreloadRoute
  '/admin/providers': typeof AppAdminProvidersRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/devices/': typeof AppDevicesIndexRoute
  '/devices/$deviceId/popout': typeof SessionDevicesDeviceIdPopoutRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/changelog': typeof AppChangelogRoute
  '/my-phones': typeof AppMyPhonesRoute
  '/providers': typeof AppProvidersRoute
  '/settings': typeof AppSettingsRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/network': typeof AppAdminNetworkRoute
  '/admin/preload': typeof AppAdminPreloadRoute
  '/admin/providers': typeof AppAdminProvidersRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/devices': typeof AppDevicesIndexRoute
  '/devices/$deviceId/popout': typeof SessionDevicesDeviceIdPopoutRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_session': typeof SessionRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/changelog': typeof AppChangelogRoute
  '/_app/my-phones': typeof AppMyPhonesRoute
  '/_app/providers': typeof AppProvidersRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/network': typeof AppAdminNetworkRoute
  '/_app/admin/preload': typeof AppAdminPreloadRoute
  '/_app/admin/providers': typeof AppAdminProvidersRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/devices/$deviceId': typeof AppDevicesDeviceIdRoute
  '/_app/devices/': typeof AppDevicesIndexRoute
  '/_session/devices/$deviceId/popout': typeof SessionDevicesDeviceIdPopoutRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/changelog'
    | '/my-phones'
    | '/providers'
    | '/settings'
    | '/admin/audit'
    | '/admin/network'
    | '/admin/preload'
    | '/admin/providers'
    | '/admin/settings'
    | '/admin/users'
    | '/devices/$deviceId'
    | '/devices/'
    | '/devices/$deviceId/popout'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/changelog'
    | '/my-phones'
    | '/providers'
    | '/settings'
    | '/admin/audit'
    | '/admin/network'
    | '/admin/preload'
    | '/admin/providers'
    | '/admin/settings'
    | '/admin/users'
    | '/devices/$deviceId'
    | '/devices'
    | '/devices/$deviceId/popout'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_session'
    | '/login'
    | '/_app/changelog'
    | '/_app/my-phones'
    | '/_app/providers'
    | '/_app/settings'
    | '/_app/admin/audit'
    | '/_app/admin/network'
    | '/_app/admin/preload'
    | '/_app/admin/providers'
    | '/_app/admin/settings'
    | '/_app/admin/users'
    | '/_app/devices/$deviceId'
    | '/_app/devices/'
    | '/_session/devices/$deviceId/popout'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  SessionRoute: typeof SessionRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_session': {
      id: '/_session'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/changelog': {
      id: '/_app/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AppChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-phones': {
      id: '/_app/my-phones'
      path: '/my-phones'
      fullPath: '/my-phones'
      preLoaderRoute: typeof AppMyPhonesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/providers': {
      id: '/_app/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof AppProvidersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/network': {
      id: '/_app/admin/network'
      path: '/admin/network'
      fullPath: '/admin/network'
      preLoaderRoute: typeof AppAdminNetworkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/preload': {
      id: '/_app/admin/preload'
      path: '/admin/preload'
      fullPath: '/admin/preload'
      preLoaderRoute: typeof AppAdminPreloadRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/providers': {
      id: '/_app/admin/providers'
      path: '/admin/providers'
      fullPath: '/admin/providers'
      preLoaderRoute: typeof AppAdminProvidersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/': {
      id: '/_app/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AppDevicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/devices/$deviceId': {
      id: '/_app/devices/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/devices/$deviceId'
      preLoaderRoute: typeof AppDevicesDeviceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_session/devices/$deviceId/popout': {
      id: '/_session/devices/$deviceId/popout'
      path: '/devices/$deviceId/popout'
      fullPath: '/devices/$deviceId/popout'
      preLoaderRoute: typeof SessionDevicesDeviceIdPopoutRouteImport
      parentRoute: typeof SessionRoute
    }
  }
}

interface AppRouteChildren {
  AppChangelogRoute: typeof AppChangelogRoute
  AppMyPhonesRoute: typeof AppMyPhonesRoute
  AppProvidersRoute: typeof AppProvidersRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminNetworkRoute: typeof AppAdminNetworkRoute
  AppAdminPreloadRoute: typeof AppAdminPreloadRoute
  AppAdminProvidersRoute: typeof AppAdminProvidersRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppDevicesDeviceIdRoute: typeof AppDevicesDeviceIdRoute
  AppDevicesIndexRoute: typeof AppDevicesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChangelogRoute: AppChangelogRoute,
  AppMyPhonesRoute: AppMyPhonesRoute,
  AppProvidersRoute: AppProvidersRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminNetworkRoute: AppAdminNetworkRoute,
  AppAdminPreloadRoute: AppAdminPreloadRoute,
  AppAdminProvidersRoute: AppAdminProvidersRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppDevicesDeviceIdRoute: AppDevicesDeviceIdRoute,
  AppDevicesIndexRoute: AppDevicesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface SessionRouteChildren {
  SessionDevicesDeviceIdPopoutRoute: typeof SessionDevicesDeviceIdPopoutRoute
}

const SessionRouteChildren: SessionRouteChildren = {
  SessionDevicesDeviceIdPopoutRoute: SessionDevicesDeviceIdPopoutRoute,
}

const SessionRouteWithChildren =
  SessionRoute._addFileChildren(SessionRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  SessionRoute: SessionRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
